module.exports = __webpack_public_path__ + "static/media/Rocket-Riches-V.73d4a83e.png";